import React from 'react'

const WebDesign = () => {
  return (
    <>
      <h1>Welcome to WebDesign Component</h1>
    </>
  )
}

export default WebDesign
